import { Component, OnInit } from '@angular/core';
import { RegisterVM } from '../../../models';
import { SignupService } from '../../../services/signup.service';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ReferenceDataService } from '../../../services/referencedata.service';
import { BaseComponent } from '../../base/base.component';
import { Utils } from '../../../utils/utils';
//import { window } from 'rxjs/operator/window';

@Component({
  selector: 'signup-step1',
  templateUrl: './step1.component.html'
})
export class Step1Component extends BaseComponent implements OnInit {

  model: RegisterVM;
  emailAlreadyUsed: boolean = false;

  constructor(private service: SignupService,
    private refService: ReferenceDataService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
    super(route);
    this.service.resetRegistration();
    this.model = service.model;
  }

  ngOnInit(): void {
    let emailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    this.myForm = this.formBuilder.group({
      email: new FormControl('', [Validators.email, Validators.required, Validators.pattern(emailRegEx)]),
      password: new FormControl('', [Validators.required, Validators.pattern(this.globalSettings.passwordRules)]),
      confirmPassword: new FormControl('', Validators.required)
    }, { validator: Utils.checkIfMatchingPasswords('password', 'confirmPassword') });

  }

  onSubmit(value: string): void {
    if (this.myForm.valid) {
      this.emitDisplayLoadingDialog(true);
      this.service.validateEmailAddress(this.model.email)
        .subscribe(
          (returnValue) => this.proceedToNextStep(returnValue),
          error => { },
          () => { this.emitDisplayLoadingDialog(false); }
        );
    }
  }

  proceedToNextStep(result: boolean): void {
    if (result == true) {
      if (window.location.href.endsWith('/NHS')) this.model.isNHS = true;
      if (!window.location.href.endsWith('/signup')) this.model.Organisation = decodeURI(window.location.href.split('/').pop());
      this.router.navigateByUrl('/signup-2');
    }
    else {
      this.emailAlreadyUsed = true;
    }
  }
}
